import { render, staticRenderFns } from "./card-cedrow-with-tabel.vue?vue&type=template&id=50731b67&scoped=true&"
import script from "./card-cedrow-with-tabel.vue?vue&type=script&lang=js&"
export * from "./card-cedrow-with-tabel.vue?vue&type=script&lang=js&"
import style0 from "./card-cedrow-with-tabel.vue?vue&type=style&index=0&id=50731b67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50731b67",
  null
  
)

export default component.exports